import {
	type LeaseActionableApprovalState,
	type LeaseApprovalTypes,
	SET_LEASE_ACTION_COUNT,
} from "./types"

const initialState: LeaseActionableApprovalState = { actionableRequestCount: 0 }

export function leaseApprovalsReducer(
	state = initialState,
	action: LeaseApprovalTypes,
): LeaseActionableApprovalState {
	switch (action.type) {
		case SET_LEASE_ACTION_COUNT:
			return { ...state, actionableRequestCount: action.payload }
		default:
			return state
	}
}
